const environment = {
  production: false,
  url: 'https://qtool.dev.digilacca.com.ar/qtool',
  // url: 'http://localhost:9012/qtool',
  //url: '/api'
};

export { environment };
